// extracted by mini-css-extract-plugin
export var loadingSpinner = "_49-1";
export var standaloneTable = "_49-0";